import React from 'react';
import {observer} from 'mobx-react';
import {Panel, CopyableField, ActionLink} from 'components';
import {t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import useModal from 'shared/hooks/useModal';
import CalendarInstructionsModal from './CalendarInstructionsModal';

const CalendarLinkRow = observer(({name, link}) => {
  return (
    <div className='col-12 sm-col-8'>
      <div className='h4 jumbo mb1'>{name}</div>
      <CopyableField fieldValue={link}/>
    </div>
  );
});

const CalendarLinks = observer(({uiState}) => {
  const {employeeCalendars, calendarSubscriptions} = uiState;

  return (
    <div className='space-y-2'>
      {employeeCalendars.map(employeeCalendar =>
        <CalendarLinkRow
          key={employeeCalendar.externalId}
          name={t(`models.calendar_type.${employeeCalendar.calendar.calendarType}.name`)}
          link={employeeCalendar.links.calendarFeed}
        />
      )}
      {calendarSubscriptions.map(calendarSubscription =>
        <CalendarLinkRow
          key={calendarSubscription.externalId}
          name={calendarSubscription.name}
          link={calendarSubscription.links.calendarFeed}
        />
      )}
    </div>
  );
});

const Calendars = observer(({uiState}) => {
  const {hasCalendars} = uiState;
  const calendarInstructionsModalOpen = useModal(uiState, 'CalendarInstructionsModal');

  if (!hasCalendars) return null;

  return (
    <Panel>
      <Panel.Header
        title={t('user_settings.calendars.Company Calendars')}
        description={<React.Fragment>
          <FormattedMessage id='user_settings.calendars.Use the following links to subscribe to calendar feeds for your company.'/>&nbsp;
          <ActionLink onClick={() => uiState.openCalendarInstructionsModal()}>
            <FormattedMessage id='user_settings.calendars.Learn more'/>
          </ActionLink>
        </React.Fragment>}
      />
      <CalendarLinks uiState={uiState}/>
      <CalendarInstructionsModal modalOpen={calendarInstructionsModalOpen} uiState={uiState}/>
    </Panel>
  );
});

export default Calendars;
